<template>
	<div :style="divStyle" style="height:100%;padding:10px;text-align:center;">
		<Spin fix v-show="isSpinShow">
			<Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
			<div>Loading</div>
		</Spin>
		<Tabs>
			<TabPane label="设备开户" name="tree" icon="ios-git-merge">
				<Steps :current="current" :offset-top="20">
					<Step title="完善用户信息"></Step>
					<Step title="选择开户设备"></Step>
					<Step title="开户结果提示"></Step>
				</Steps>
				<step3 v-if="showStep3" ref="step3" :result="result" :msg="msg" :on-ok="callBackReturn"></step3>
				<div v-if="showStep2">
					<div style="width:50%; left:25%; position:relative; margin-top:15px;">
						<Row>
							<Col span="24">
							<span>当前户主 {{" " + formValidate.idCard}} {{" " + formValidate.name}}</span>
							</Col>
						</Row>
						<Row>
							<Col span="20">
							<Cascader filterable v-model="addressSelected" :data="addressData" change-on-select trigger="click"></Cascader>
							</Col>
							<Col span="4">
							<Button style="float:left" type="primary" shape="circle" icon="ios-search" @click="searchMeter">点击检索设备</Button>
							</Col>
						</Row>
					</div>
					<div style="margin:20px">
						<Table :loading="tableLoading" @on-selection-change="selectTableRow" size="small" ref="meterTable" :columns="columns3" :data="data1" v-model="selectedMeterItem"></Table>
						<Page style="margin:20px;" :current="pageNo" :total="pageTotal" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40]" show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />
					</div>
				</div>
				<div v-if="showStep1">
					<div style="width:70%; left:30%; position:relative; margin-top:15px;">
						<Row span="24" :gutter="8">
							<Col span="12">
							<Input search enter-button v-model="searchIdCard" placeholder="请输入身份证号" @on-search="search" />
							</Col>
							<Col span="6">
							<Button icon="md-cloud-download" long type="primary" @click="exportCustomerTemplate">导出用户模板</Button>
							</Col>
							<Col span="6">
							<Button type="primary" long icon="md-cloud-upload" onclick="$('#upload_file_customer').click();">按用户模板导入</Button>
							</Col>
						</Row>
						<Upload ref="upload" name="upfile" action="/api/importCustomerTemplate" :on-success="handleImportCustomerTemplate" :format="['xlsx','xls']" :show-upload-list="false">
							<input id="upload_file_customer" style="display: none;" />
						</Upload>
					</div>
					<div v-show="showCustomerInfo" style="width:60%; left:15%; position:relative;text-align:left; margin:20px">
						<!-- <Scroll :height="height - 300" style="margin:20px;"> -->
						<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
							<FormItem label="户名" prop="name">
								<Input v-model="formValidate.name" placeholder="请输入户名"></Input>
							</FormItem>
							<FormItem label="手机号" prop="phone">
								<Input v-model="formValidate.phone" placeholder="请输入手机号"></Input>
							</FormItem>
							<FormItem label="身份证号" prop="idCard">
								<Input v-model="formValidate.idCard" placeholder="请输入身份证号"></Input>
							</FormItem>
							<FormItem label="成员总数" prop="memberAmount">
								<Input v-model="formValidate.memberAmount" placeholder="请输入成员总数"></Input>
							</FormItem>
							<FormItem label="备注" prop="remark">
								<Input v-model="formValidate.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder></Input>
							</FormItem>
						</Form>
						<!-- </Scroll> -->
					</div>
				</div>

				<div style="right:  70px;margin-top:15px">
					<Button v-if="showStep2" style="margin-left: 20px;" type="primary" @click="pre">上一步</Button>
					<Button v-if="!showStep3" style="margin-left: 20px;" type="primary" @click="next">下一步</Button>
				</div>
			</TabPane>
			<TabPane label="开户记录" name="list" icon="ios-list">
				<Row style="padding-bottom: 10px;">
					<Col span="4" style="padding-right: 10px;">
					<Button type="primary" long @click="onClickSearch">检索</Button>
					</Col>
				</Row>
				<Table ref="selectionTable" :max-height="height * 0.8" :data="showData" :columns="showColumns" stripe border></Table>
				<Page :current="currentPage" :total="dataCount" :page-size="pageListSize" show-sizer show-total @on-change="changeListPage" @on-page-size-change="changeListPageSize" style="text-align:right"></Page>
			</TabPane>
		</Tabs>
		<!-- 模态框 -->
		<Modal v-model="isShowModalSearch" :mask-closable="false" width="380">
			<p slot="header" style="color:#2d8cf0;text-align:center">
				<Icon type="md-create" />
				<span>按照输入的字段检索</span>
			</p>
			<Form ref="searchParam" :label-width="100" :model="searchParam">
				<FormItem prop="addressLowestLevelAddressId" label="地址：">
					<Cascader :data="addressData" change-on-select filterable transfer @on-change="chooseAddress"></Cascader>
				</FormItem>
				<FormItem prop="customerName" label="户主姓名：">
					<Input v-model="searchParam.customerName" clearable placeholder="请输入户主姓名..."></Input>
				</FormItem>
				<FormItem prop="customerIdcard" label="身份证号：">
					<Input v-model="searchParam.customerIdcard" clearable placeholder="请输入身份证号..."></Input>
				</FormItem>
				<FormItem prop="acountStatus" label="开户状态：">
					<Select v-model="searchParam.acountStatus" clearable placeholder="请选择开户状态...">
						<Option value=1>已开户</Option>
						<Option value=0>未开户</Option>
					</Select>
				</FormItem>
				<FormItem prop="meterIds" label="设备编号：">
					<Input v-model="searchParam.meterIds" clearable placeholder="请输入设备编号..."></Input>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" size="large" long @click="commitSearch">检索</Button>
			</div>
		</Modal>
	</div>
</template>
<script>
	import step3 from "./expand/opResult.vue";
	export default {
		name: "open_account",
		components: {
			step3
		},
		mounted() {
			this.getAddresTree();
			this.showPage();
		},
		computed: {
			divStyle() {
				var style = {};
				if (this.$parent.$refs.mainContent) {
					style.width = this.$parent.$refs.mainContent.clientWidth - 54 + "px";
				} else {
					style.width = window.innerWidth - 279 + "px";
				}
				//style.height = (this.$parent.$refs.mainContent.clientHeight - 54) + 'px';
				return style;
			}
		},
		methods: {
			showPage() {
				let that = this;
				that.isSpinShow = true;
				// if(that.searchParam.acountStatus === "0"){
				//     that.searchParam.acountStatus = 0;
				// } else if(that.searchParam.acountStatus === "1"){
				//     that.searchParam.acountStatus = 1;
				// }
				$.ajax({
					url: "/api/viewAddressAccount/selectPage?page=" +
						that.currentPage +
						"&pageAmount=" +
						that.pageListSize,
					contentType: "application/json",
					type: "post",
					data: JSON.stringify(that.searchParam),
					dataType: "json",
					success: function(data) {
						if (data.errorCode != 0) {
							that.$Notice.error({
								title: "异常",
								desc: data.errorInfo
							});
							return;
						}
						that.showData = data.body.resultList;
						that.dataCount = data.body.amount;
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					},
					complete: function() {
						that.isSpinShow = false;
					}
				});
			},
			changeListPage(index) {
				this.currentPage = index;
				this.showPage();
			},
			changeListPageSize(size) {
				this.pageSize = size;
				this.showPage();
			},
			onClickSearch() {
				this.isShowModalSearch = true;
			},
			commitSearch() {
				console.log(this.searchParam);
				this.isShowModalSearch = false;
				this.showPage();
			},
			chooseAddress(param) {
				console.log(param);
				if (param.length > 0) {
					this.searchParam.addressLowestLevelAddressId = param[param.length - 1] * 1; //当复选框选中时则会打印出选中的内容
				} else {
					this.searchParam.addressLowestLevelAddressId = null;
				}
			},
			selectTableRow(selection, row) {
				this.selectedMeterItem = selection;
			},
			searchMeter() {
				this.getMeterByAddress(
					this.addressSelected[this.addressSelected.length - 1]
				);
			},
			search() {
				this.customerExist = false;
				var that = this;
				$.ajax({
					url: "/api/getCustomerInfoByConditions",
					contentType: "application/json",
					type: "post",
					dataType: "json",
					async: false,
					data: JSON.stringify({
						idCard: that.searchIdCard
					}),
					success: function(data) {
						if (data.errorCode != 0) {
							that.$Notice.error({
								title: "异常",
								desc: data.errorInfo
							});
							return;
						}
						that.showCustomerInfo = true;
						if (data.body[0] == undefined) {
							that.$Notice.warning({
								title: "提示",
								desc: "当前用户不存在，请完善用户信息"
							});
							that.formValidate.id = null;
							that.formValidate.idCard = that.searchIdCard;
							that.formValidate.name = "";
							that.formValidate.phone = "";
							that.formValidate.gasType = "";
							that.formValidate.memberAmount = 1;
							that.formValidate.remark = "";
						} else {
							that.$Notice.success({
								title: "提示",
								desc: "获取用户信息成功"
							});
							that.customerExist = true;
							that.formValidate.id = data.body[0].customerId;
							that.formValidate.idCard = that.searchIdCard;
							that.formValidate.name = data.body[0].customerName;
							that.formValidate.phone = data.body[0].customerPhone;
							that.formValidate.gasType = data.body[0].customerGasType;
							that.formValidate.memberAmount =
								data.body[0].customerFamilyMemberAmount;
							that.formValidate.remark = data.body[0].customerRemark;
						}
					},
					error: function(textStatus) {
						that.spinShow = false;
						that.$Notice.error({
							title: "异常",
							desc: "接口调用异常"
						});
					}
				});
			},

			selectAddress() {
				//   console.log(this.addressData);
				//   console.log(this.addressSelected);
			},

			// 修改页面容量
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.getMeterByAddress(
					this.addressSelected[this.addressSelected.length - 1]
				);
			},
			// 修改
			changePage(index) {
				this.pageNo = index;
				console.log(this.pageNo);
				this.getMeterByAddress(
					this.addressSelected[this.addressSelected.length - 1]
				);
			},
			getMeterByAddress(addressId) {
				this.tableLoading = true;
				var that = this;
				that.selectedMeterItem = [];
				$.ajax({
					url: "/api/getMeterInfoByConditions",
					contentType: "application/json",
					type: "post",
					data: JSON.stringify({
						page: that.pageNo,
						amount: that.pageSize,
						addressId: addressId,
						conditions: {
							customerIdCardOR: that.formValidate.idCard
						}
					}),
					dataType: "json",
					success: function(data) {
						if (data.errorCode != 0) {
							that.$Notice.error({
								title: "异常",
								desc: data.errorInfo
							});
							that.tableLoading = false;
							return;
						}
						that.$Notice.success({
							title: "提示",
							desc: "载入设备数据成功"
						});

						for (var i = 0; i < data.body.resultList.length; i++) {
							if (data.body.resultList[i].meterUsageState != 0 && data.body.resultList[i].customerId != undefined) {
								data.body.resultList[i]._disabled = true;
							}
							if (
								data.body.resultList[i].customerId != undefined &&
								data.body.resultList[i].customerId != that.formValidate.id
							) {
								data.body.resultList[i]._disabled = true;
							}
						}
						that.data1 = data.body.resultList;
						that.pageTotal = data.body.amount;
						that.tableLoading = false;
					},
					error: function(textStatus) {
						that.loading = false;
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
						that.tableLoading = false;
					}
				});
			},
			insertOrUpdateCustomer() {
				var that = this;
				$.ajax({
					url: "/api/saveOrUpdateCustomer",
					contentType: "application/json",
					type: "post",
					dataType: "json",
					async: false,
					data: JSON.stringify({
						id: that.formValidate.id,
						name: that.formValidate.name,
						phone: that.formValidate.phone,
						gasType: that.formValidate.gasType,
						idCard: that.formValidate.idCard,
						memberAmount: that.formValidate.memberAmount,
						remark: that.formValidate.remark,
						opType: that.customerExist == true ? "update" : "save"
					}),
					success: function(data) {
						if (data.errorCode != 0) {
							that.$Notice.error({
								title: "异常",
								desc: data.errorInfo
							});
							return;
						}
						that.showCustomerInfo = true;
						that.$Notice.success({
							title: "提示",
							desc: "用户信息录入成功"
						});

						that.formValidate.id = data.body.customerId;
						that.next();
					},
					error: function(textStatus) {
						that.spinShow = false;
						that.$Notice.error({
							title: "异常",
							desc: "接口调用异常"
						});
					}
				});
			},
			getAddresTree() {
				var that = this;
				$.ajax({
					url: "/api/getAddressTree",
					contentType: "application/json",
					type: "get",
					dataType: "json",
					success: function(data) {
						if (data.errorCode != 0) {
							that.$Notice.error({
								title: "异常",
								desc: data.errorInfo
							});
							return;
						}

						that.addressData = data.body[0].children;
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "地址获取异常"
						});
					}
				});
			},
			openAccount() {
				this.$Modal.confirm({
					title: "提示",
					content: "<p>若未绑定的设备将绑定用户信息并开通，若已绑定用户信息将只开通设备，确认进行操作吗？</p>",
					onOk: () => {
						var that = this;
						this.isSpinShow = true;
						$.ajax({
							url: "/api/openAccount",
							contentType: "application/json",
							type: "post",
							async: true,
							data: JSON.stringify({
								customerId: that.formValidate.id,
								selection: that.selectedMeterItem
							}),
							dataType: "json",
							success: function(data) {
								if (data.errorCode != 0) {
									that.$Notice.info({
										title: "提示",
										desc: data.errorInfo
									});
									that.result = "fail";
								} else {
									that.$Notice.success({
										title: "提示",
										desc: "开户成功"
									});
								}

								that.selectedMeterItem = data.body;
								var str = "";
								for (var i = 0; i < that.selectedMeterItem.length; i++) {
									str =
										str +
										that.selectedMeterItem[i].completeAddress +
										"<br/>" +
										that.selectedMeterItem[i].meterId +
										"号设备<br/>";
									if (that.selectedMeterItem[i].customerBindResult !=
										undefined) {
										str =
											str +
											that.selectedMeterItem[i].customerBindResult +
											"<br/>";
									}
									// if (
									//     that.selectedMeterItem[i].meterRegisterResult !=
									//     undefined
									// ) {
									//     str =
									//         str +
									//         that.selectedMeterItem[i].meterRegisterResult +
									//         "<br/>";
									// }
								}
								that.msg = str;
								that.result = "success";
							},
							error: function(textStatus) {
								that.loading = false;
								that.$Notice.error({
									title: "异常",
									desc: "接口请求异常"
								});
								that.result = "fail";
							},
							complete: function(XMLHttpRequest, textStatus) {
								that.isSpinShow = false;
								++that.current;
								that.showStep2 = false;
								that.showStep3 = true;
								that.$refs.step3.changeStatus(that.result);
							}
						});
					},
					onCancel: () => {
						--this.current;
						this.showStep1 = false;
						this.showStep2 = false;
						this.showStep3 = false;
						this.showStep2 = true;
					}
				});
			},
			next() {
				this.showStep1 = false;
				this.showStep2 = false;
				this.showStep3 = false;
				switch (this.current) {
					case 0:
						this.showStep1 = true;
						if (this.formValidate.id == null) {
							// 进入第二步之前对用户信息进行插入或更新
							this.$refs.formValidate.validate(valid => {
								if (valid) {
									this.insertOrUpdateCustomer();
									if (this.addressSelected.length && this.addressSelected) {
										this.getMeterByAddress(
											this.addressSelected[this.addressSelected.length - 1]
										);
									}
								} else {
									this.$Notice.warning({
										title: "提示",
										desc: "请完善用户信息"
									});
								}
							});
						} else {
							++this.current;
							this.showStep1 = false;
							this.showStep2 = true;
						}
						break;
					case 1:
						this.showStep2 = true;
						if (this.selectedMeterItem.length == 0) {
							this.$Notice.warning({
								title: "提示",
								desc: "请选择开户设备"
							});
						} else {
							this.openAccount();
						}
						break;
					case 2:
						this.showStep3 = true;
						break;
				}
			},
			pre() {
				if (this.current == 0) {
					return;
				}

				--this.current;
				this.showStep1 = false;
				this.showStep2 = false;
				this.showStep3 = false;
				switch (this.current) {
					case 0:
						// this.formValidate = {
						// 	id: null,
						// 	name: "",
						// 	phone: "",
						// 	gasType:"",
						// 	idCard: "",
						// 	memberAmount: 1,
						// 	remark: ""
						// };
						// this.showCustomerInfo = false;
						// this.searchIdCard = "";
						this.showStep1 = true;
						break;
					case 1:
						this.showStep2 = true;
						break;
					case 2:
						this.showStep3 = true;
						break;
				}
			},
			callBackReturn() {
				this.current = 0;
				this.showStep1 = true;
				this.showStep2 = false;
				this.showStep3 = false;
				this.getMeterByAddress(
					this.addressSelected[this.addressSelected.length - 1]
				);
			},
			exportCustomerTemplate() {
				window.location.href = this.customerUrl;
			},
			handleImportCustomerTemplate(response, file, fileList) {
				console.log(response);
				console.log(file);
				console.log(fileList);
				this.handelResponse(response);
			},
			handelResponse(response) {
				if (response.errorCode != 0) {
					this.$Notice.error({
						title: "导入失败",
						desc: response.errorInfo,
						duration: 0
					});
				} else {
					let result = response.body.repeatArray;
					let insert = response.body.insertArray;
					let count = "\n共计导入" + insert.length + "条数据。";
					let indexs = "";
					if (result.length > 0) {
						result.map(item => {
							indexs =
								indexs == "" ? item.index + 2 : indexs + "," + (item.index + 2);
						});
					}
					let msg =
						indexs == "" ?
						"" :
						"\n第" + indexs + "行数据与数据库中数据重复,不予导入。";
					this.$Notice.success({
						title: "成功",
						desc: "导入成功！" + msg + count,
						duration: 0
					});
					this.showPage();
				}
			},
			handleError(error, file, fileList) {
				console.log(error);
				console.log(file);
				console.log(fileList);
				this.$Notice.error({
					title: "导入失败",
					desc: error,
					duration: 0
				});
			}
		},
		data() {
			const validateMemberAmount = (rule, value, callback) => {
				var r = /^\+?[1-9][0-9]*$/; //正整数
				var flag = r.test(value);
				if (!flag) {
					callback(new Error("请输入成员总数(正整数)..."));
				} else {
					callback();
				}
			};
			const validatePhone = (rule, value, callback) => {
				var r = /^1[3|4|5|7|8][0-9]{9}$/;
				var flag = r.test(value);
				if (!flag) {
					callback(new Error("请输入正确的手机号..."));
				} else {
					callback();
				}
			};
			const validateIdCard = (rule, value, callback) => {
				var r = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/;
				var flag = r.test(value);
				if (!flag) {
					callback(new Error("请输入正确的身份证号码..."));
				} else {
					callback();
				}
			};
			return {
				isSpinShow: false,
				currentPage: 1,
				dataCount: 0,
				pageListSize: 10,
				isShowModalSearch: false,
				showData: [],
				showColumns: [{
						title: "地址",
						key: "addressLowestLevelAddressIds",
						width: 350
					},
					{
						title: "户主姓名",
						key: "customerName"
					},
					{
						title: "身份证号",
						key: "customerIdcard",
						width: 200
					},
					{
						title: "开户状态",
						key: "acountStatus",
						render: function(h, params) {
							let acountStatusName = "";
							if (this.row.acountStatus) {
								acountStatusName = "已开户";
							} else {
								acountStatusName = "未开户";
							}
							return h('div', acountStatusName);
						}
					},
					{
						title: "设备编号",
						key: "meterIds",
						width: 300
					}
				],
				searchParam: {},
				columns3: [{
						type: "selection",
						width: 60,
						align: "center"
					},
					{
						title: "设备号",
						key: "meterId"
					},
					{
						title: "地址",
						key: "completeAddress"
					},
					{
						title: "设备类型",
						key: "meterTypeName"
					},
					{
						title: "户主姓名",
						key: "customerName"
					},
					{
						title: "户主证件号",
						key: "customerIdcard"
					},
					{
						title: "是否绑定用户",
						key: "customerId",
						render: (h, params) => {
							if (params.row.customerId != undefined) {
								return h("span", "已绑定");
							} else {
								return h("span", "未绑定");
							}
						}
					},
					{
						title: "设备状态",
						key: "meterUsageState",
						render: (h, params) => {
							if (params.row.meterUsageState == 0) {
								return h("span", "待开通");
							} else {
								return h("span", "已开通");
							}
						}
					}
				],
				msg: "",
				result: "success",
				data1: [],
				addressSelected: 0,
				addressData: [],
				customerExist: false,
				showCustomerInfo: false,
				searchIdCard: "",
				current: 0,
				showStep1: true,
				showStep2: false,
				showStep3: false,
				showStep4: false,
				pageTotal: 0,
				pageSize: 5,
				pageNo: 1,
				tableLoading: false,
				selectedMeterItem: [],
				height: document.body.clientHeight,
				width: document.body.clientWidth,
				formValidate: {
					id: "",
					name: "",
					phone: "",
					idCard: "",
					memberAmount: 1,
					remark: ""
				},
				ruleValidate: {
					name: [{
						required: true,
						message: "请输入户名",
						trigger: "blur"
					}],
					phone: [{
						required: true,
						validator: validatePhone,
						trigger: "blur"
					}],
					gasType: [{
						required: true,
						message: "请选择用气类型",
						trigger: "change"
					}],
					idCard: [{
						required: true,
						validator: validateIdCard,
						trigger: "blur"
					}],
					memberAmount: [{
						required: true,
						validator: validateMemberAmount,
						trigger: "change"
					}]
				},
				customerUrl: "/api/downloadCustomerTemplate"
			};
		}
	};
</script>
